import { Island, Service } from '../types/api';
import { Navigation } from 'lucide-react';

interface Props {
  islands: Island[];
  services: Service[];
  selectedIsland: string;
  selectedService: string;
  locationLoading: boolean;
  onIslandChange: (island: string) => void;
  onServiceChange: (service: string) => void;
  onUseLocation: () => void;
}

export default function ClinicFilters({
  islands,
  services,
  selectedIsland,
  selectedService,
  locationLoading,
  onIslandChange,
  onServiceChange,
  onUseLocation,
}: Props) {
  return (
    <div className="card">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="label">Island</label>
          <select
            value={selectedIsland}
            onChange={(e) => onIslandChange(e.target.value)}
            className="input"
          >
            <option value="">All Islands</option>
            {islands.map((i) => (
              <option key={i.island} value={i.island}>
                {i.island} ({i.clinic_count})
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="label">Service</label>
          <select
            value={selectedService}
            onChange={(e) => onServiceChange(e.target.value)}
            className="input"
          >
            <option value="">All Services</option>
            {services.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
      </div>
      <button
        onClick={onUseLocation}
        disabled={locationLoading}
        className="btn btn-primary btn-sm mt-4"
      >
        <Navigation className="w-4 h-4" />
        {locationLoading ? 'Locating...' : 'Use My Location'}
      </button>
    </div>
  );
}
